import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';
import { motion } from 'framer-motion';

const translations = {
  en: {
    volunteer: 'Become a Volunteer',
    joinUs: 'Join Our Mission'
  },
  hi: {
    volunteer: 'स्वयंसेवक बनें',
    joinUs: 'हमारे मिशन में शामिल हों'
  }
};

const FloatingVolunteerButton: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="fixed bottom-24 right-8 z-50">
      <Link
        to="/volunteer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="relative group"
      >
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.5 }}
          className="relative"
        >
          <motion.div
            animate={{
              scale: isHovered ? 1.05 : 1,
              rotate: isHovered ? 5 : 0
            }}
            transition={{ duration: 0.2 }}
            className="bg-gradient-to-r from-primary to-secondary text-white px-6 py-3 rounded-full shadow-lg flex items-center space-x-2 cursor-pointer"
          >
            <span className="font-semibold">{t.volunteer}</span>
            <svg
              className="w-5 h-5 transform group-hover:translate-x-1 transition-transform"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </motion.div>

          {/* Tooltip */}
          {isHovered && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{ duration: 0.2 }}
              className="absolute bottom-full right-0 mb-2 w-48 bg-white text-gray-800 p-3 rounded-lg shadow-xl"
            >
              <p className="text-sm font-medium">{t.joinUs}</p>
              <div className="absolute bottom-0 right-4 transform translate-y-1/2 rotate-45 w-2 h-2 bg-white"></div>
            </motion.div>
          )}

          {/* Pulse effect */}
          <motion.div
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 0, 0.5]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            className="absolute inset-0 bg-primary rounded-full opacity-50"
          />
        </motion.div>
      </Link>
    </div>
  );
};

export default FloatingVolunteerButton; 